import { Cookie } from 'storage-manager-js';

Alpine.data('contentWarning', (id) => {
	const cookieName = `content-warn-${id}`;

	return {
		visible: false,

		init() {
			if (!Cookie.has(cookieName)) {
				this.visible = true;
			}
		},
		close() {
			this.visible = false;

			Cookie.set(cookieName, true, {
				expires: 1, // 1 day.
			});
		},
	};
});
